

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { Router } from '@angular/router';
import { UserStaffDetailDto } from '@cradua/data';
import Swal from "sweetalert2";
import { GatewayFacade } from './../../../../../gateway/src/lib/states/+gateway/gateway.facades';
import { AuthFacade } from './../../../../../auth/src/lib/facades/auth.facade';

import { GatewayService } from  'libs/gateway/src/lib/services/gateway.service';

import { Guid } from "guid-typescript";
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../../../../../../apps/epims/mrsoftepims/src/app/services/auth.service';

@Component({
  selector: 'cradua-contractor-staff',
  templateUrl: './contractor-staff.component.html',
  styleUrls: ['./contractor-staff.component.css']
})
export class ContractorStaffComponent implements OnInit {

  href: string = "";
  staffForm: FormGroup;
  staffinfolist: any;
  contractors = [];
  contractorstaffs = [];
  searchcontractorstaff = [];
  staffs = [];
  editstatus = false;
  staff = new EventEmitter<UserStaffDetailDto>();
  user: any;
  
  constructor(private fb: FormBuilder, private router: Router, private gatewayFacade: GatewayFacade, 
     public authServ: AuthenticationService,
     private authFade: AuthFacade, 
    private gatewayService: GatewayService, private matSnackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.user = this.authServ.getUser();

    this.createForm();
   this.getRegisteredStaff();

   let location =  window.location.href.split('#')[0];

  this.href = location;
  }
 
  createForm() {
    this.staffForm = this.fb.group({
      ParentId: ['', Validators.required],
      StaffId: [""],
      LastName: ["", Validators.required],
      FirstName: ["", Validators.required],
      MiddleName: [""],
      PhoneNo: ["", Validators.required],
      EmailAddress: ["", Validators.required],
      SubscriberId: this.user.SubscriberId,
      StaffName: [""],
      password:[""],
      id: null,
    });
  }
  resetForm() {
    this.editstatus = false;
    this.createForm();
  }
  getRegisteredStaff(){

    this.gatewayFacade.loadGateway('IdentityUser').subscribe(users => {
      this.staffs = users
      this.contractors = users.filter(user => user.UserType === 'Contractor');
      this.contractorstaffs = users.filter(user => user.UserType === 'ContractorStaff');
      this.searchcontractorstaff = this.contractorstaffs;
    });

    this.gatewayFacade.loadGateway("UserStaffDetail").subscribe((staffinfoe) => {
      this.staffinfolist = staffinfoe;
    });
   
 }
 searchContractorsStaff(name: string) {
   if(name.length > 0) {
    this.searchcontractorstaff = this.contractorstaffs.filter(a => a.StaffName.toLowerCase().includes(name.toLowerCase()))

   } else {
     this.searchcontractorstaff = this.contractorstaffs;
   }
 }

 onEdit(data) {
  //  console.log('data', data);
   this.editstatus = true;
  this.staffForm.patchValue(data);
  this.staffForm.patchValue({EmailAddress: data.Email});
 }

 updateStaff(pullData) {
  
  const findStaffDetail = this.staffinfolist.find(user => user.EmailAddress === pullData.EmailAddress || user.PhoneNo === pullData.PhoneNo)
 
  if(findStaffDetail) {

   let staffDetail = pullData;
  //  console.log(findStaffDetail);

   staffDetail.id = findStaffDetail.id
   this.gatewayFacade.add("UserStaffDetail", staffDetail);
 }

  let user = {
    UserName: pullData.EmailAddress,
    PhoneNo: pullData.PhoneNo,
    FirstName: pullData.FirstName,
    LastName: pullData.LastName,
    StaffName: pullData.StaffName,
    SubscriberId: this.user.SubscriberId,
    Id:  pullData.id,
  };
  let newData = [];
  newData.push(user)
  this.authFade.addNewUser(newData);
 }


 onSubmit() {

  const pullData = this.staffForm.value;
  const user = this.staffs.find(staff => staff.Email === pullData.EmailAddress || staff.PhoneNo === pullData.PhoneNo );
  if(user) return this.matSnackBar.open('Staff already exists! Please check the email or phone number and try again', 'Exit', {duration: 3000});
  pullData.StaffName = this.staffForm.value.LastName + ", " +
  this.staffForm.value.FirstName;

if (this.staffForm.value.id === "" || this.staffForm.value.id === null) {

  if (
    this.staffForm.value.FirstName === "" ||
    this.staffForm.value.LastName === "" ||
    this.staffForm.value.PhoneNo === "" ||
    this.staffForm.value.EmailAddress === "" || this.staffForm.value.ParentId === ''
  ) {
    Swal.fire(
      "Please ensure that the compulsory fields are entered",
      "Incomplete Details!",
      "error",
    );
    return;
  }
   delete this.staffForm.value.id;
 
  this.gatewayFacade.add("UserStaffDetail", this.staffForm.value);


  const date = new Date();
  date.setDate(date.getDate() + 2);


  // this.userUpdate.resetPasswordExpires = date;
  // this.userUpdate.resetPasswordToken = this.generateRandomString(35);


 
 
  let user = {
    ParentId: pullData.ParentId,
    UserName: pullData.EmailAddress,
    Email: pullData.EmailAddress,
    PhoneNo: pullData.PhoneNo,
    FirstName: pullData.FirstName,
    LastName: pullData.LastName,
    StaffName: pullData.StaffName,
    password: 'welcome',
    UserType: 'ContractorStaff',
    SubscriberId: pullData.SubscriberId,
    userRole: 'ContractorStaff',
    Id:  Guid.create().toString(),
    resetPasswordExpires: date,
    resetPasswordToken: this.generateRandomString(35)

  };

  let newAdd = [];
  newAdd.push(user)


   
  let mailData = { fromEmail: '', toEmail: user.Email, subject: 'Manage Account', task:'', responsibility: '',
  pipelinename: '', pipelinerequestdesc: '', period: '', message: '', salutation: '', footer: '', url: ''};

  let salute = "Dear " + user.StaffName + ' ,';

  let conformButtonMsg = "";


  mailData.salutation = salute;
 
  mailData.message = "Click on the link below to change your password";
  
  mailData.footer = '';
 

 let linkURL = this.href + '#/auth/manage/' + user.Id + '/' + user.resetPasswordToken;
 mailData.url = linkURL;
 
//  console.log("Sending mail ", mailData, user.Id);
  this.gatewayService.sendManageAccountMail(mailData).subscribe((data) => {

 });

 this.staffForm.reset;

  this.authFade.addNewUser(newAdd);

 
 
 
} else {
  //update here .....

  // console.log("Updated Data ", pullData);
  pullData.StaffName = this.staffForm.value.LastName + ", " +
    this.staffForm.value.FirstName + " " +
    this.staffForm.value.MiddleName;
  //this.gatewayFacade.update("UserStaffDetail");

  // Swal.fire(
  //   "Staff details updated",
  //   "Details Updated!",
  //   "success",
  // );
}
   
 }


 generateRandomString (length, randomString="") {
  randomString += Math.random().toString(20).substr(2, length);
  if (randomString.length > length) return randomString.slice(0, length);
  return this.generateRandomString(length, randomString);
};

}
